import { QueryList } from '@angular/core';
import { Subject } from 'rxjs';
import { ChipNotResponsiveComponent } from '../chip-notResponsive/chip-notResponsive.component';
var ChipsListNotResponsiveComponent = (function () {
    function ChipsListNotResponsiveComponent() {
        this.ngUnsubscribe = new Subject();
        this.multiple = false;
    }
    ChipsListNotResponsiveComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.chips.toArray().forEach(function (item) {
            item.select.takeUntil(_this.ngUnsubscribe).subscribe(function (args) {
                if (args) {
                    _this.itemSelected(args);
                }
            });
        });
        this.chips.changes.subscribe(function (change) {
            _this.chips.toArray().forEach(function (item) {
                //item.select.unsubscribe();
                item.select.takeUntil(_this.ngUnsubscribe).subscribe(function (args) {
                    if (args) {
                        _this.itemSelected(args);
                    }
                });
            });
        });
    };
    ChipsListNotResponsiveComponent.prototype.itemSelected = function (item) {
        if (!this.multiple) {
            this.chips.toArray().forEach(function (item, index) {
                item.selected = false;
            });
            item.selected = true;
        }
        else {
            item.selected = !item.selected;
        }
    };
    /**
     * On destroy cancel active subscriptions
     */
    ChipsListNotResponsiveComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    return ChipsListNotResponsiveComponent;
}());
export { ChipsListNotResponsiveComponent };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/chips/chips-list-notResponsive/chips-list-notResponsive.component.ts.pre-build-optimizer.js